<template>
  <v-speed-dial v-if="connected" v-model="active" absolute fab bottom right direction="left" transition="slide-x-reverse-transition">
      <template v-slot:activator>
        <v-btn v-model="active" :style="'background-color:' + getColor()" dark fab>
          <v-icon v-if="!active">{{mdiPencil}}</v-icon>
          <v-icon v-else>{{mdiClose}}</v-icon>
        </v-btn>
      </template>
      <v-btn fab dark small style="background-color: #445057" v-on:click="engageReaper()">
        <v-icon>{{mdiCoffin}}</v-icon>
      </v-btn>
      <v-btn fab dark small :style="'background-color:' + getColor()" v-on:click="modeChanged('thumbs')">
        <v-icon>{{mdiThumbUp}}</v-icon>
      </v-btn>
      <v-btn fab dark small :style="'background-color:' + getColor()" v-on:click="modeChanged('tshirt')">
        <v-icon>{{mdiTshirtCrew}}</v-icon>
      </v-btn>
      <v-btn fab dark small :style="'background-color:' + getColor()" v-on:click="modeChanged('fibonacci')">
        <v-icon>{{mdiNumeric}}</v-icon>
      </v-btn>
    </v-speed-dial>
</template>

<script>
import { mdiPencil, mdiClose,mdiNumeric, mdiTshirtCrew, mdiThumbUp, mdiCoffin } from '@mdi/js'

export default {
  name: 'changeModeBtn',
  data () {
    return {
      active: false,
      mdiNumeric,
      mdiTshirtCrew,
      mdiThumbUp,
      mdiPencil,
      mdiClose,
      mdiCoffin,
    }
  },
  props: {
    connected: Boolean,
    tableId: String
  },
  methods: {
    modeChanged: function (mode) {
      this.$socket.emit('mode', { tableId: this.tableId, value: mode })
    },
    engageReaper: function() {
      this.$socket.emit('victim', this.tableId)
    },
    itsChristmas: function () {
      return this.$store.state.holidaysMode === 'christmas'
    },
    itsEaster: function () {
      return this.$store.state.holidaysMode === 'easter'
    },
    getColor: function() {
      if(this.itsChristmas())
        return "#F44336"
      else if(this.itsEaster())
        return "#FFC107"
      return "#4676be"
    }
  }
}
</script>

<style scoped>
.v-speed-dial--bottom {
  bottom: 50%
}
</style>